import React from 'react';
import {Typography, Tag, Switch} from 'antd';

import {format, FORMAT_LONG} from '@/util/dateUtils';
import _ from "lodash";

const {Text} = Typography;

const columnDefines = ({onStatusChangeClick = _.noop} = {}) => ({
    jobName: {
        title: '任务名称',
        dataIndex: 'jobName',
        width: 250,
    },
    jobGroup: {
        title: '任务组名',
        width: 130,
        dataIndex: 'jobGroup',
        render: text => {
            if (text == 'DEFAULT') {
                return <Tag color="green">默认</Tag>;
            } else if (text == 'SYSTEM') {
                return <Tag color="green">系统</Tag>;
            } else if (text == 'MEDIA') {
                return <Tag color="green">图文</Tag>;
            }
            return '';
        },
    },
    invokeTarget: {
        title: '调用目标字符串',
        dataIndex: 'invokeTarget',
    },
    cronExpression: {
        title: 'cron表达式',
        dataIndex: 'cronExpression',
        width: 150,
    },
    status: {
        title: '状态',
        dataIndex: 'status',
        width: 100,
        render: (text, record) => {
            // 0 正常 1 暂停
            const isChecked = text === '0' ? true : false;
            return (<Switch checkedChildren="正常" unCheckedChildren="暂停" checked={isChecked}
                            onChange={onStatusChangeClick(record)}/>);
        },
    },
    createTime: {
        title: '创建时间',
        dataIndex: 'createTime',
        width: 200,
        render: text => {
            return <Text>{format(text, FORMAT_LONG)}</Text>;
        },
    },
    updateTime: {
        title: '更新时间',
        dataIndex: 'updateTime',
        width: 200,
        render: text => {
            return <Text>{format(text, FORMAT_LONG)}</Text>;
        },
    },
});

export function getColumns(keys, options) {
    return keys.map(key => columnDefines(options)[key]).filter(Boolean);
}
